exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".shared-weather-component{display:none}.shared-weather-component__today-min-max{white-space:nowrap}.shared-weather-component__weather-card{display:inline-block;padding:16px}.shared-weather-component__weather-card-date{font-size:20px!important}.shared-weather-component__weather-card-temp{font-size:15px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/pages/shared/weather.scss
// module id = 1034
// module chunks = 0